export interface IFilterClause {
  operator: string;
}

export interface ILeafFilterClause extends IFilterClause {
}

export interface ICompositeFilterClause extends IFilterClause {
  clauses: ILeafFilterClause[];
}

export interface IStringValuedFilterClause extends ILeafFilterClause {
  value: string;
}

export interface IFieldFilterClause extends ILeafFilterClause {
  field: string;
}

export interface IValuedFieldFilterClause<T> extends IFieldFilterClause {
  value: T;
}

export interface IStringArrayValuedFieldFilterClause extends IFieldFilterClause {
  values: string[];
}

export var FilterOps = {
  and: 'and',
  eq: 'eq',
  lte: 'lte',
  gte: 'gte',
  has: 'has',
  inArray: 'in',
  matches: 'matches',
  or: 'or'
};

export var FilterFieldNames = {
  connectionType: 'connectionType',
  createdAt: 'createdAt',
  databaseUsername: 'databaseUsername',
  datasourceId: 'datasourceId',
  domainId: 'domainId',
  domainName: 'domainName',
  groupId: 'groupId',
  groupIds: 'groupIds',
  hasAlert: 'hasAlert',
  hasExtracts: 'hasExtracts',
  hasEmbeddedPassword: 'hasEmbeddedPassword',
  isCertified: 'isCertified',
  isDefaultPort: 'isDefaultPort',
  isEmbedded: 'isEmbedded',
  isFavorite: 'isFavorite',
  isPublished: 'isPublished',
  isRecent: 'isRecent',
  lastRefreshedAt: 'lastRefreshedAt',
  maxSiteRole: 'maxSiteRole',
  minimumSiteRole: 'minimumSiteRole',
  ownerId: 'ownerId',
  parentId: 'parentId',
  parentType: 'parentType',
  projectId: 'projectId',
  scheduledAction: 'scheduledAction',
  scheduleId: 'scheduleId',
  serverName: 'serverName',
  serverPort: 'serverPort',
  siteId: 'siteId',
  siteRole: 'siteRole',
  tags: 'tags',
  updatedAt: 'updatedAt',
  userId: 'userId',
  urlName: 'repositoryUrl',
  workbookId: 'workbookId'
};
